module.exports = __webpack_public_path__ + "static/img/file.dd702f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/file.jpg
// module id = R4Bt
// module chunks = 2